// extracted by mini-css-extract-plugin
export var grid = "_1w-0";
export var span1 = "_1w-2";
export var span10 = "_1w-b";
export var span10L = "_1w-z";
export var span10M = "_1w-n";
export var span10Xl = "_1w-1b";
export var span11 = "_1w-c";
export var span11L = "_1w-10";
export var span11M = "_1w-o";
export var span11Xl = "_1w-1c";
export var span12 = "_1w-d";
export var span12L = "_1w-11";
export var span12M = "_1w-p";
export var span12Xl = "_1w-1d";
export var span1L = "_1w-q";
export var span1M = "_1w-e";
export var span1Xl = "_1w-12";
export var span2 = "_1w-3";
export var span2L = "_1w-r";
export var span2M = "_1w-f";
export var span2Xl = "_1w-13";
export var span3 = "_1w-4";
export var span3L = "_1w-s";
export var span3M = "_1w-g";
export var span3Xl = "_1w-14";
export var span4 = "_1w-5";
export var span4L = "_1w-t";
export var span4M = "_1w-h";
export var span4Xl = "_1w-15";
export var span5 = "_1w-6";
export var span5L = "_1w-u";
export var span5M = "_1w-i";
export var span5Xl = "_1w-16";
export var span6 = "_1w-7";
export var span6L = "_1w-v";
export var span6M = "_1w-j";
export var span6Xl = "_1w-17";
export var span7 = "_1w-8";
export var span7L = "_1w-w";
export var span7M = "_1w-k";
export var span7Xl = "_1w-18";
export var span8 = "_1w-9";
export var span8L = "_1w-x";
export var span8M = "_1w-l";
export var span8Xl = "_1w-19";
export var span9 = "_1w-a";
export var span9L = "_1w-y";
export var span9M = "_1w-m";
export var span9Xl = "_1w-1a";
export var stretch = "_1w-1";